'use client'

import { useState } from 'react'
import ResultsTable from '@/components/results'
import Podium from '@/components/podium'
import { useTournament } from '@/hooks/useTournament'

export default function Home() {
  const savedTournament = useTournament()
  const [podium, setPodium] = useState(null)

  if (!savedTournament) return null;

  return (
    <div className="ipl-prediction-leaderboard">
      <Podium podium={podium} savedTournament={savedTournament} />
      <ResultsTable setPodium={setPodium} savedTournament={savedTournament} />
    </div>
  )
}
